/* ZAR extras: color dots on product cards + prev/next arrows on the product photo. */

const SWATCH = '[data-zar-swatch]';

/* ---------- Product cards: color dots ---------- */

function rememberInitialSlides(slideshow, slides) {
  if (slideshow.dataset.zarReady) return;
  slideshow.dataset.zarReady = '1';
  for (const slide of slides) slide.dataset.zarInitialHidden = slide.hasAttribute('hidden') ? '1' : '0';
}

function selectCardColor(button) {
  const card = button.closest('product-card');
  const group = button.closest('[data-zar-card-swatches]');
  if (!card || !group) return;

  const mediaId = button.dataset.mediaId;
  const color = button.dataset.color;

  for (const item of group.querySelectorAll(SWATCH)) item.setAttribute('aria-pressed', String(item === button));

  /* Carry the chosen color to the product page. */
  for (const link of card.querySelectorAll('a[href]')) {
    let url;
    try {
      url = new URL(link.getAttribute('href'), window.location.origin);
    } catch (error) {
      continue;
    }
    if (!url.pathname.includes('/products/')) continue;
    url.searchParams.set('color', color);
    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  const slideshow = card.querySelector('slideshow-component');
  if (!slideshow) return;
  const slides = [...slideshow.querySelectorAll('slideshow-slide')];
  if (!slides.length) return;
  rememberInitialSlides(slideshow, slides);

  /* Undo any direct photo swap from an earlier pick. */
  for (const img of slideshow.querySelectorAll('img[data-zar-original-src]')) {
    img.src = img.dataset.zarOriginalSrc;
    if (img.dataset.zarOriginalSrcset) img.setAttribute('srcset', img.dataset.zarOriginalSrcset);
    delete img.dataset.zarOriginalSrc;
    delete img.dataset.zarOriginalSrcset;
  }

  let target = mediaId ? slides.find((slide) => slide.getAttribute('slide-id') === mediaId) : undefined;
  let isHome = Boolean(target) && target.dataset.zarInitialHidden === '0';

  if (!target) {
    /* No slide for this color: show its photo in the card's first slide instead. */
    const image = button.dataset.image;
    target = slides.find((slide) => slide.dataset.zarInitialHidden === '0');
    const img = target ? target.querySelector('img') : null;
    if (!image || !img) return;
    img.dataset.zarOriginalSrc = img.currentSrc || img.src;
    img.dataset.zarOriginalSrcset = img.getAttribute('srcset') || '';
    img.removeAttribute('srcset');
    img.src = image;
    isHome = false;
  }

  for (const slide of slides) {
    if (isHome) slide.toggleAttribute('hidden', slide.dataset.zarInitialHidden === '1');
    else slide.toggleAttribute('hidden', slide !== target);
    slide.removeAttribute('reveal');
  }
  target.setAttribute('aria-hidden', 'false');
  card.toggleAttribute('data-zar-single-image', !isHome);

  const slideId = target.getAttribute('slide-id');
  if (slideId && typeof slideshow.select === 'function') {
    slideshow.select({ id: slideId }, undefined, { animate: false });
  }
  const scroller = slideshow.querySelector('slideshow-slides');
  if (scroller) {
    window.requestAnimationFrame(() => {
      const left = target.getBoundingClientRect().left - scroller.getBoundingClientRect().left + scroller.scrollLeft;
      if (Math.abs(scroller.scrollLeft - left) > 1) scroller.scrollTo({ left, behavior: 'instant' });
    });
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const more = event.target.closest('[data-zar-swatch-more]');
  if (more) {
    event.preventDefault();
    const group = more.closest('[data-zar-card-swatches]');
    if (group) for (const item of group.querySelectorAll('[data-zar-swatch-extra]')) item.hidden = false;
    more.hidden = true;
    return;
  }

  const swatch = event.target.closest(SWATCH);
  if (swatch) {
    event.preventDefault();
    selectCardColor(swatch);
  }
});

/* ---------- Product page: prev/next arrows on the main photo ---------- */

const chevron = (direction) =>
  '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true"><path d="' +
  (direction < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') +
  '" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

function setupGallery(thumbs) {
  const gallery = thumbs.parentElement;
  if (!gallery || gallery.dataset.zarArrows) return;
  const main = gallery.querySelector('.zar874-main-image');
  const photo = gallery.querySelector('.zar874-photo') || (main ? main.parentElement : null);
  if (!photo) return;
  gallery.dataset.zarArrows = '1';
  photo.classList.add('zar-gallery-photo');

  const step = (direction) => {
    const buttons = [...thumbs.querySelectorAll('button')];
    if (buttons.length < 2) return;
    const current = Math.max(0, buttons.findIndex((button) => button.getAttribute('aria-pressed') === 'true'));
    buttons[(current + direction + buttons.length) % buttons.length].click();
  };

  const makeArrow = (direction, label) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'zar-gallery-arrow ' + (direction < 0 ? 'zar-gallery-arrow--prev' : 'zar-gallery-arrow--next');
    button.setAttribute('aria-label', label);
    button.innerHTML = chevron(direction);
    button.addEventListener('click', () => step(direction));
    photo.append(button);
    return button;
  };

  const previous = makeArrow(-1, 'Previous image');
  const next = makeArrow(1, 'Next image');

  const sync = () => {
    const single = thumbs.querySelectorAll('button').length < 2;
    previous.hidden = single;
    next.hidden = single;
  };
  new MutationObserver(sync).observe(thumbs, { childList: true });
  sync();

  /* Swipe left/right on touch screens. */
  let startX = 0;
  let startY = 0;
  let tracking = false;
  photo.addEventListener('touchstart', (event) => {
    tracking = event.touches.length === 1;
    if (!tracking) return;
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  }, { passive: true });
  photo.addEventListener('touchend', (event) => {
    if (!tracking) return;
    tracking = false;
    const touch = event.changedTouches[0];
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) step(dx < 0 ? 1 : -1);
  }, { passive: true });
}

function setupGalleries() {
  for (const thumbs of document.querySelectorAll('.zar874 [data-thumbnails]')) setupGallery(thumbs);
}

/* ---------- Product page: open in the color chosen on a card ---------- */

function applyColorFromUrl() {
  const url = new URL(window.location.href);
  const wanted = url.searchParams.get('color');
  if (!wanted) return;
  const host = document.querySelector('.zar874');
  if (!host) return;

  const pick = () => {
    const match = [...host.querySelectorAll('[data-swatch-color]')].find(
      (button) => (button.dataset.swatchColor || '').toLowerCase() === wanted.toLowerCase()
    );
    if (!match) return false;
    if (match.getAttribute('aria-pressed') !== 'true') match.click();
    const clean = new URL(window.location.href);
    clean.searchParams.delete('color');
    window.history.replaceState(window.history.state, '', clean.toString());
    return true;
  };

  if (pick()) return;
  const observer = new MutationObserver(() => {
    if (pick()) observer.disconnect();
  });
  observer.observe(host, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
}

function init() {
  setupGalleries();
  applyColorFromUrl();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();

document.addEventListener('shopify:section:load', setupGalleries);
